import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (e) {
            setError(formatApiError(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-sf-bg p-8"
            data-testid="forgot-password-page"
        >
            <div className="w-full max-w-sm">
                <Link to="/">
                    <Logo className="h-24 w-auto mb-10" />
                </Link>
                <div className="label-eyebrow mb-3">Recupero password</div>
                <h1 className="font-display text-4xl text-navy mb-3">
                    Password dimenticata?
                </h1>
                <p className="text-sf-secondary mb-8 text-sm">
                    Inserisci l'email del tuo account. Ti invieremo un link
                    sicuro per impostare una nuova password.
                </p>

                {done ? (
                    <div
                        className="bg-[#2d6a4f]/10 border border-[#2d6a4f]/30 text-[#1d4030] p-4 rounded-md text-sm mb-6"
                        data-testid="forgot-done"
                    >
                        Se l'email è registrata, riceverai a breve un messaggio
                        con il link per reimpostare la password. Controlla
                        anche la cartella spam.
                    </div>
                ) : (
                    <form onSubmit={submit} data-testid="forgot-form">
                        {error && (
                            <div
                                className="mb-4 p-3 text-sm bg-red-50 border border-red-200 text-red-700 rounded-md"
                                data-testid="forgot-error"
                            >
                                {error}
                            </div>
                        )}
                        <div className="mb-6">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="mt-2"
                                data-testid="forgot-email"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={busy}
                            className="w-full bg-navy hover:bg-navy/90 text-white lift"
                            data-testid="forgot-submit"
                        >
                            {busy ? "Invio in corso…" : "Invia link di reset"}
                        </Button>
                    </form>
                )}

                <div className="mt-6 text-sm text-sf-secondary text-center">
                    <Link
                        to="/login"
                        className="text-navy font-semibold underline"
                        data-testid="forgot-back-login"
                    >
                        ← Torna al login
                    </Link>
                </div>
            </div>
        </div>
    );
}
